import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { BasicDoc, Hit } from "react-instantsearch-core";

import HitCard from "../hit/hitcard";

const useStyles = makeStyles((theme) => ({
  cardrow: {
    display: "flex",
    overflowX: "scroll",
    width: "100%",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    willChange: "scroll-position",
    // scrollPadding: "50%",
  },
  card: {
    display: "inline-block",
    flex: 1,
  },
  cardrowItem: {
    flexShrink: 0,
    scrollSnapAlign: "center",
    maxWidth: 360,
    minWidth: 360,
  },
}));

const HitsCarousel: React.FunctionComponent<any> = (props) => {
  const { hits }: { hits: Hit<BasicDoc>[] } = props;
  const classes = useStyles();

  return (
    <Box>
      {hits.map((hit: Hit<BasicDoc>, i: number): JSX.Element => {
        return (
          <HitCard className={classes.card} key={`hit-${hit.id}`} hit={hit} />
        );
      })}
    </Box>
  );
};

export default HitsCarousel;
